import { render, staticRenderFns } from "./endotoxinas_ipress.vue?vue&type=template&id=b80f0148&scoped=true"
import script from "./endotoxinas_ipress.vue?vue&type=script&lang=js"
export * from "./endotoxinas_ipress.vue?vue&type=script&lang=js"
import style0 from "./endotoxinas_ipress.vue?vue&type=style&index=0&id=b80f0148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80f0148",
  null
  
)

export default component.exports